import React, { Fragment, useEffect, useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography
} from '@mui/material'
import { useApi } from '../../../hooks/useApi'
import { AsnDetailReceiveLpn, AsnDetailReceiveLpnInfo } from '../Interfaces'
import { CheckCircle, Update, WatchLater } from '@mui/icons-material'
import { getListLpn } from '../api'
import { useStyles } from '../styles'
import { Status } from '../../../hooks/useFetchState'

interface HistoryLpnReceivedProps {
  asnNumber?: string
  asnId?: number
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const HistoryLpnReceived: React.FC<HistoryLpnReceivedProps> = ({
  asnNumber,
  asnId,
  openSnackBar
}) => {
  const classes = useStyles()
  const { callApi, state } = useApi<AsnDetailReceiveLpnInfo[]>()
  const [loading, setLoading] = useState(true)
  const [lpnReceived, setLpnReceived] = useState<AsnDetailReceiveLpnInfo[]>([])
  const [lpnReceivedFilter, setLpnReceivedFilter] = useState<boolean>()

  const requestGetListLpn = () => {
    const queryString: AsnDetailReceiveLpn = {
      lpnReceived: lpnReceivedFilter
    }
    callApi(getListLpn(asnId || 0, queryString))
      .then((response: AsnDetailReceiveLpnInfo[]) => {
        setLpnReceived(response)
        setLoading(false)
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
  }

  useEffect(() => {
    requestGetListLpn()
  }, [lpnReceivedFilter])

  return (
    <Fragment>
      {loading ? (
        <CircularProgress />
      ) : (
        <Fragment>
          <Typography style={{ fontWeight: 'bold' }}>
            ASN: {asnNumber}
          </Typography>
          <Grid item xs={12} sm={6} md={12} style={{ textAlign: 'center' }}>
            <Button onClick={() => setLpnReceivedFilter(undefined)}>
              <Update color='primary' />
            </Button>
            <Button
              onClick={() => {
                setLpnReceivedFilter(true)
              }}
            >
              Recibidos
              <CheckCircle style={{ color: 'green' }} />
            </Button>
            <Button
              onClick={() => {
                setLpnReceivedFilter(false)
              }}
            >
              Pendientes
              <WatchLater color='error' />
            </Button>
          </Grid>
          <Box
            component='div'
            display='flex'
            flexDirection='column'
            flexWrap='nowrap'
            alignItems='center'
            padding='3px'
            className={classes.containerList}
          >
            <Box
              component='div'
              display='flex'
              flexDirection='column'
              flexWrap='nowrap'
              alignItems='center'
              width={'90%'}
            >
              {state.status === Status.Loading ? (
                <CircularProgress />
              ) : (
                <Fragment>
                  {lpnReceived.length == 0
                    ? 'Sin resultados'
                    : lpnReceived.map((lpnReceived) => (
                        <Box padding={'3px'} width={'100%'}>
                          <Button
                            fullWidth
                            variant='contained'
                            style={{ cursor: 'default' }}
                          >
                            {lpnReceived.lpn}
                            {lpnReceived.lpnReceived ? (
                              <CheckCircle style={{ color: 'green' }} />
                            ) : (
                              <WatchLater color='error' />
                            )}
                          </Button>
                        </Box>
                      ))}
                </Fragment>
              )}
            </Box>
          </Box>
        </Fragment>
      )}
    </Fragment>
  )
}
